import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import moment from 'moment';

import {
  AllChatProps,
  CampaignDataProps,
  ConversationFiltersProps,
} from '../../core/types/_models';
import {
  getAllChatsByCampaignId,
  getCampaignById,
  getChatsByCampaignId,
} from '../../core/requests/requests';
import CampaignByIdHeader from './components/CampaignByIdHeader';
import CampaignByIdLeads from './components/CampaignByIdLeads';
import CampaignByIdDetails from './components/CampaignByIdDetails';
import CampaignByIdPreview from './components/CampaignByIdPreview';

const CampaignById: React.FC = () => {
  const { campaignId } = useParams();
  const [campaignData, setCampaignData] = useState<CampaignDataProps | null>(
    null
  );
  const [chats, setChats] = useState<AllChatProps[]>([]);

  const handleGetCampaignById = async () => {
    try {
      if (campaignId) {
        const { data } = await getCampaignById(campaignId);
        if (data) {
          setCampaignData(data);
        }
      }
    } catch (error) {}
  };

  const handleGetChatsByCampaignId = async () => {
    try {
      if (campaignId) {
        const { data } = await getAllChatsByCampaignId(campaignId);
        if (data) {
          setChats(data?.chats);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (campaignId) {
      handleGetCampaignById();
      handleGetChatsByCampaignId();
    }
  }, [campaignId]);

  return (
    <div className="campaign-by-id__container">
      <CampaignByIdHeader
        campaignName={campaignData?.name ?? ''}
        numberOfChats={chats.length ?? 0}
        campaignId={campaignData?.id ?? ''}
      />
      <div className="campaign-by-id__content-container">
        <div className="campaign-by-id__content-column">
          <CampaignByIdLeads currentCampaignId={campaignData?.id ?? ''} />
          <CampaignByIdPreview
            currentCampaignId={campaignData?.id ?? ''}
            campaignInitialMessage={campaignData?.initialMessage ?? null}
          />
        </div>
        <div className="campaign-by-id__content-column">
          <CampaignByIdDetails campaignData={campaignData} />
        </div>
      </div>
    </div>
  );
};

export default CampaignById;
